/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

export class FirebaseStateError extends Error {
	public projectId: string;
	public constructor(message: string, projectId: string) {
		super(message);
		this.projectId = projectId;
	}
}
